module.exports = __webpack_public_path__ + "img/img_accredit_qr.a29c399f.svg";